import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import LoginFlow from '../components/LoginFlow';
import { PATHS } from '../paths';
import { useAuthState } from '../providers/AuthProvider';

const LoginScene = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthState();

  React.useEffect(() => {
    if (isAuthenticated) {
      void navigate(PATHS.HOME);
    }
  }, [isAuthenticated, navigate]);

  return <LoginFlow />;
};

export default LoginScene;
